import { TableCell, Typography } from '@mui/material';

type ShareInvoicesTableHeaderCellProps = {
  text: React.ReactNode;
};

export const ShareInvoicesTableHeaderCell: React.FC<ShareInvoicesTableHeaderCellProps> = ({ text }) => {
  return (
    <TableCell
      sx={{
        paddingX: '0px',
      }}
    >
      <Typography
        color="primary"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "24px"
        }}>
        {text}
      </Typography>
    </TableCell>
  );
};
